/** PetAlerts SQL Table */

export enum PetAlerts {
	PetRequiresSpecialHandling = 1,
	Blind = 2,
	Deaf = 3,
	HeartMurmur = 4,
	HeartwormPositive = 5,
	Muzzle = 6,
	VaccineReaction = 7,
	FelineLeukemia = 21,
	MWIBordetella = 45,
	MWIBordetellaDA2hHPPLepto = 46,
	MWIBordetellaDA2HPPLepto = 47,
	MWIBordetellaDA2HPPLeptoH3N2H3N8 = 48,
	MWIBordetellaDA2HPPV = 49,
	MWIBordetellaDA2HPPvH3N2H3N8 = 50,
	MWIBordetellaDA2HPPvH3N2H3N8Lepto = 51,
	MWIBordetellaDA2HPPvLepto = 52,
	MWIBordetellaH3N2H3N8Lepto = 53,
	MWIBordetellaLepto = 54,
	MWIDA2HPPLepto = 55,
	MWIDA2HPPLeptoH3N2H3N8 = 56,
	MWIDA2HPPv = 57,
	MWIDA2HPPvH3N2H3N8 = 58,
	MWIDa2HPPvLepto = 59,
	MWIFelineLeukemia = 60,
	MWIFVRCP = 61,
	MWIFVRCPFelineLeukemia = 62,
	MWIFVRCPFeLv = 63,
	MWIFVRCPFeLvFelineLeukemia = 64,
	MWIH3N2H3N8 = 65,
	MWIH3N2H3N8Lepto = 66,
	MWILepto = 67,
	Lunges = 68,
	WillBite = 69,
	Caution = 70,
	Aggressive = 71,
	Fearful = 72,
	WearGloves = 73,
	Contagious = 74,
	Diabetic = 75,
	Epileptic = 76,
	Chemotherapy = 77,
	FIVPositive = 78,
	MedicationReaction = 79,
	Seizures = 80,
	FoodAllergy = 81,
	DogAggressive = 82,
	RequiresSedation = 83,
	NoJugularBloodDraw = 84,
	ExamineAwayfromOwner = 85,
	BloodworkExamDue = 86,
	CheckCommunications = 87,
	NoTabletop = 88,
	BottomKennelOnly = 89,
	SpanishSpeaking = 90,
	AnesthesiaReaction = 91,
}
